import React, { useContext, useEffect, useState } from "react";
import { LoginUserContext } from "../provider/LoginUserProvider";
import { Navigate } from "react-router-dom";
import Header from "../template/Header";
import { Box, Typography } from "@mui/material";
import MonthlySummary from "../MonthlySummary";
import Calendar from "../Calendar";
import useWorkoutsFetch from "../hooks/useWorkoutsFetch";
import axios from "axios";
import { WorkoutContext } from "../provider/WorkoutProvider";
import { format } from "date-fns";
import { formatMonth } from "../../utils/formatting";
import TransactionMenu from "../TransactionMenu";
import TransactionForm from "../TransactionForm";
// import TransactionMenu from "../TransactionMenu";

const Home = ({
  setCurrentMonth,
  currentMonth,
  //  onSaveTransaction
}) => {
  const { isLogined, loading } = useContext(LoginUserContext);
  const {
    transactions,
    setTransactions,
    onGetWorkouts,
    onSaveTransaction,
    selectedTransaction,
    setSelectedTransaction,
  } = useContext(WorkoutContext);
  const { workoutsFetch } = useWorkoutsFetch();
  const today = format(new Date(), "yyyy-MM-dd");
  const [currentDay, setCurrentDay] = useState(today);
  const [isEntryDrawerOpen, setIsEntryDrawerOpen] = useState(false); // TransactionForm

  useEffect(() => {
    if (loading || !isLogined) return;
    onGetWorkouts();
  }, [loading, isLogined]);

  const monthlyTransactions = transactions.filter((transaction) => {
    // return transaction.date.startsWith(format(currentMonth, "yyyy-MM"));
    return transaction.date.startsWith(formatMonth(currentMonth));
  });

  const dailyTransactions = monthlyTransactions.filter((transaction) => {
    return transaction.date === currentDay;
  });

  console.log("Home render");
  console.log("transactions", transactions);
  console.log("monthlyTransactions", monthlyTransactions);

  const onCloseForm = () => {
    setIsEntryDrawerOpen(!isEntryDrawerOpen);
    setSelectedTransaction(null);
  };

  // ワークアウトを選択した時の処理
  const handleSelectTransaction = (transaction) => {
    setIsEntryDrawerOpen(true);
    setSelectedTransaction(transaction);
  };

  // フォームの開閉処理
  const handleAddTransactionForm = () => {
    if (selectedTransaction) {
      setSelectedTransaction(null);
    } else {
      setIsEntryDrawerOpen(!isEntryDrawerOpen);
    }
  };

  if (loading) {
    return (
      <>
        <Typography>ロード中</Typography>
      </>
    );
  }

  if (!isLogined) {
    return <Navigate to="/login" />;
  } else {
    return (
      <>
        <Box sx={{ display: "flex", padding: 2 }}>
          {/* 左側コンテンツ */}
          <Box sx={{ flexGrow: 1 }}>
            <MonthlySummary monthlyTransactions={monthlyTransactions} />
            <Calendar
              monthlyTransactions={monthlyTransactions}
              setCurrentMonth={setCurrentMonth}
              setCurrentDay={setCurrentDay}
              currentDay={currentDay}
              today={today}
              // onDateClick={handleDateClick}
            />
          </Box>
          {/* 右側コンテンツ */}
          <Box>
            <TransactionMenu
              dailyTransactions={dailyTransactions}
              currentDay={currentDay}
              onAddTransactionForm={handleAddTransactionForm}
              onSelectTransaction={handleSelectTransaction}
              // isMobile={isMobile}
              // open={isMobileDrawerOpen}
              // onClose={handleCloseMobileDrawer}
            />
            <TransactionForm
              isEntryDrawerOpen={isEntryDrawerOpen}
              onCloseForm={onCloseForm}
              currentDay={currentDay}
              onSaveTransaction={onSaveTransaction}
              selectedTransaction={selectedTransaction}
              // onDeleteTransaction={onDeleteTransaction}
              // setSelectedTransaction={setSelectedTransaction}
              // onUpdateTransaction={onUpdateTransaction}
              // isMobile={isMobile}
              // isDialogOpen={isDialogOpen}
              // setIsDialogOpen={setIsDialogOpen}
            />
          </Box>
        </Box>
      </>
    );
  }
};

export default Home;
